<template>
  <div class="new-blog-post posts">
    <form
      @submit.prevent="save"
      @keydown="clearError($event)"
      autocomplete="no"
    >
      <div class="post-nav">
        <div class="container-fluid d-flex justify-content-between">
          <div class="d-flex align-items-center nav-left">
            <button
              type="button"
              class="btn btn-back"
              @click="$router.push('/posts')"
            ></button>
            <h1 class="w-full nav-tittle2">Create new post</h1>
          </div>
          <div class="d-flex align-items-center nav-right">
            <button class="btn btn-primary mr-4"><b>CREATE POST</b></button>
            <!--            <button type="button" class="btn btn-secondary dots-btn">
              <i class="fa fa-ellipsis-v"></i>
            </button>-->
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row post-main pb-10p">
          <div class="col-md-7 info-section-left">
            <div class="section-title">POST INFO</div>
            <div class="form-group info-width height-50">
              <label>Post title</label>
              <input
                class="form-control"
                placeholder="Select post title"
                v-model="post.title"
              />
            </div>
            <error-field
              :errors="errors"
              field="title"
              class="material-errors"
            />
            <div class="form-group info-width texteditor">
              <label class="descriptionArea">Post body</label>
              <trumbowyg
                v-model="post.content"
                :config="editorConfig"
                class="form-control"
                name="content"
              ></trumbowyg>
            </div>
            <error-field
              :errors="errors"
              field="content"
              class="material-errors"
            />
          </div>

          <div class="col-md-5 info-section-right">
            <div class="section-title">POST CATEGORY</div>
            <div class="select-wrap post-category-input">
              <label>Category</label>
              <simple-select
                placeholder="Select category"
                :options="categories"
                label="name"
                v-model="post.category_id"
              />
            </div>
            <error-field
              :errors="errors"
              field="category_id"
              class="material-errors"
            />

            <div class="section-title mt-4">POST TAGS</div>
            <div class="post-tags-input">
              <!--<label>POST TAGS</label>-->
              <multiselect
                v-model="selectedTags"
                v-if="tags"
                :options="tags"
                :multiple="true"
                class=""
                :clear-on-select="false"
                :hide-selected="true"
                :preserve-search="false"
                label="tag"
                track-by="id"
              >
                <template slot="tag" slot-scope="props">
                  <span class="multiselect__tag">
                    <span>{{ props.option.tag }}</span>
                    <span
                      class="multiselect__tag-icon"
                      @click="props.remove(props.option)"
                    />
                  </span>
                </template>
              </multiselect>
            </div>
            <div class="section-title mt-4">POST LANG</div>
            <div class="select-wrap post-category-input">
              <label>Language</label>
              <simple-select
                placeholder="Select language"
                :options="langs"
                label="name"
                v-model="post.lang"
              />
            </div>
            <error-field
              :errors="errors"
              field="lang"
              class="material-errors"
            />
          </div>
        </div>

        <div class="row post-main pb-10p">
          <div class="col-md-2 info-section-left">
            <div class="section-title">POST THUMBNAIL</div>
            <div class="d-flex custom-dimension">
              <FilesUpload
                :label="'Upload an image'"
                :strategy="'cover'"
                :recommended="'Recommended size is 450x250'"
                ref="refLogoUpload"
                @update="loadImage"
                class="image-upload"
              />
            </div>
          </div>
          <template class="gallery-div" v-if="post.page_image !== ''">
            <div class="col-md-2 upl-img">
              <div
                :style="{ backgroundImage: `url(${post.page_image})` }"
                style="background-size: cover;background-position:center; position: relative;border-radius: 2px; outline: none;"
                class="square-upload d-inline-block"
              >
                <div class="gallery-img-overlay">
                  <div class="img-delete" @click="deleteImage(post.page_image)">
                    <img src="../../assets/img/icons/gallery-close.svg" />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="col-md-3 info-section-right">
            <div class="section-title">IMG ALT TAG</div>
            <div class="form-group alt-tag-input height-50 img-alt-tag">
              <label>Alt tag</label>
              <input
                class="form-control"
                placeholder="Enter image alt tag"
                v-model="post.page_image_alt_text"
              />
            </div>
            <div class="thumbnail-wrapper">
              <div class="thumbnail-title">
                <i class="fa fa-info-circle pr-2"></i> Thumbnail alt tag
              </div>
              <div class="thumbnail-p">
                Image will be used on smaller devices and when the layout is
                showing multiple blog posts. This image will also be used when
                sharing the link for the post.
              </div>
            </div>
          </div>
          <div class="col-md-5 info-section-right">
            <div class="section-title">PUBLISH DATE & TIME</div>
            <span class="d-flex pb-30 flex-column">
              <div class="select-wrap w-full info-width">
                <label>Select a date</label>
                <div class="input-group h-full">
                  <flat-pickr
                    v-model="startTime"
                    :config="config"
                    class="w-full"
                    placeholder="Select date"
                    name="date"
                  >
                  </flat-pickr>
                </div>
              </div>
              <error-field
                :errors="errors"
                field="published_at"
                class="material-errors"
              />
            </span>

            <div class="section-title">
              POST URL
              <i
                class="fa fa-info-circle pr-2"
                data-toggle="tooltip"
                data-placement="top"
                title="Will be automagically created from title if you don’t enter shit."
              >
              </i>
            </div>
            <div class="form-group info-width height-50">
              <label>URL</label>
              <input
                class="form-control"
                placeholder="Enter post url"
                v-model="post.slug"
              />
            </div>
            <error-field
              :errors="errors"
              field="slug"
              class="material-errors"
            />
          </div>
        </div>
        <div v-if="uploadSection === ''" class="row post-main pb-10p pt-14p">
          <div class="col-md-7 info-section-left">
            <div class="section-title">POST IMAGES OR VIDEO</div>
            <div class="d-flex w-90 align-items-center">
              <div class="selectionCard" @click="uploadSection = 'video'">
                <div class="sc-title">
                  Video post
                </div>
                <div class="sc-text">
                  Chose this option if you'd like to upload a video for the post
                </div>
              </div>
              <div class="selectionCard" @click="uploadSection = 'gallery'">
                <div class="sc-title">
                  Gallery
                </div>
                <div class="sc-text">
                  Chose this option if you'd like to upload a multiple images
                  and create a gallery
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5 info-section-right"></div>
        </div>
        <div
          v-if="uploadSection === 'video'"
          class="row post-main pb-10p pt-14p"
        >
          <div class="col-md-7 info-section-left">
            <span
              class="d-flex justify-content-between align-items-center sc-title-wrapper"
            >
              <div class="section-title">POST VIDEO</div>
              <div class="linkColor" @click="uploadSection = ''">
                Choose post style
              </div>
            </span>
            <span class="d-flex">
              <div
                class="form-group info-width textarea w-full embed-textarea-wrapper"
              >
                <textarea
                  class="form-control embed-textarea w-full"
                  placeholder="Paste embedded video code here"
                  rows="10"
                  v-model="post.video_url"
                >
                </textarea>
              </div>
            </span>
          </div>
          <div class="col-md-5 info-section-right">
            <div class="section-title">EMBEDDED VIDEO ALT TAG</div>
            <div class="form-group info-width height-50">
              <label>Alt tag</label>
              <input
                class="form-control"
                placeholder="Enter embedded video alt tag"
                v-model="post.video_alt_tag"
              />
            </div>
            <div class="thumbnail-wrapper">
              <div class="thumbnail-title">
                <i class="fa fa-info-circle pr-2"></i> Embedded video
              </div>
              <div class="thumbnail-p">
                You can add a video from Youtube or Vimeo to your blog by
                embedding it.
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="uploadSection === 'gallery'"
          class="row post-main pb-10p pt-14p"
        >
          <div class="col-md-12 info-section-left">
            <span
              class="d-flex justify-content-between align-items-center sc-title-wrapper"
            >
              <div class="section-title">POST GALLERY</div>
              <div class="linkColor" @click="uploadSection = ''">
                Choose post style
              </div>
            </span>
            <div class="d-flex custom-dimension">
              <FilesUpload
                :label="'Upload an image'"
                ref="refLogoUpload"
                :maxFiles="6"
                @update="loadImageGallery"
                class="image-upload mr-12"
              />
              <template class="gallery-div" v-if="sortedImages">
                <div
                  class="mr-12"
                  v-for="image in sortedImages"
                  :key="image.image_id"
                >
                  <div
                    :id="image.image_id"
                    :style="{ backgroundImage: `url(${image.url})` }"
                    style="background-size: cover;background-position:center; position: relative;border-radius: 2px; outline: none;"
                    class="square-upload d-inline-block"
                  >
                    <div class="gallery-img-overlay">
                      <input
                        placeholder="Alt tag"
                        class="gallery-tag"
                        v-model="imageAltTags[image.image_id]"
                      />
                      <div class="img-delete" @click="deleteImage(image)">
                        <img src="../../assets/img/icons/gallery-close.svg" />
                      </div>
                      <div class="image-position-change">
                        <span
                          @click="moveImageLeft(image.order)"
                          style="width:100%"
                          ><img
                            src="../../assets/img/icons/gallery-arrow.svg"
                            class="gallery-left"
                        /></span>
                        <span class="button-line" />
                        <span
                          style="width:100%"
                          @click="moveImageRight(image.order)"
                        >
                          <img
                            src="../../assets/img/icons/gallery-arrow.svg"
                            class="gallery-right"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-5 info-section-right"></div>
        </div>

        <div class="row post-main pt-14p">
          <div class="col-md-7 info-section-left">
            <div class="section-title">SEO INFO</div>
            <div class="form-group info-width height-50 mb-0">
              <label>Page title</label>
              <input
                class="form-control"
                placeholder="Enter page title"
                v-model="post.meta_title"
              />
            </div>
            <div class="mb-2" v-if="post.meta_title">
              <span
                :class="{
                  'text-red':
                    post.meta_title.length < 50 || post.meta_title.length > 60,
                  'text-green':
                    post.meta_title.length >= 50 && post.meta_title.length <= 60
                }"
              >
                {{ post.meta_title.length }}
              </span>
              / 50-60 characters
            </div>
            <error-field
              :errors="errors"
              field="meta_title"
              class="material-errors"
            />
            <div class="form-group info-width textarea mb-0">
              <label for="seoDescriptionArea">Meta description</label>
              <textarea
                class="form-control w-full h-full"
                id="seoDescriptionArea"
                placeholder="Enter meta description for the blog post"
                rows="10"
                v-model="post.meta_description"
              ></textarea>
            </div>
            <div class="mb-2" v-if="post.meta_description">
              <span
                :class="{
                  'text-red':
                    post.meta_description.length < 150 ||
                    post.meta_description.length > 160,
                  'text-green':
                    post.meta_description.length >= 150 &&
                    post.meta_description.length <= 160
                }"
              >
                {{ post.meta_description.length }}
              </span>
              / 150-160 characters
            </div>
            <error-field
              :errors="errors"
              field="meta_description"
              class="material-errors"
            />
          </div>
          <div class="col-md-5 info-section-right"></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import Errors from "@/classes/Errors";
import ErrorField from "@/components/ErrorField";
import FilesUpload from "@/components/FilesUpload";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "NewPost",
  components: {
    FilesUpload,
    flatPickr,
    ErrorField
  },
  props: ["duplicatedPost"],
  data() {
    return {
      editorConfig: {
        btns: [
          ["viewHTML"],
          ["undo", "redo"], // Only supported in Blink browsers
          ["format"],
          ["strong", "em", "del"],
          ["superscript", "subscript"],
          ["link"],
          ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
          ["unorderedList", "orderedList"],
          ["horizontalRule"],
          ["removeformat"],
          ["fullscreen"],
          ["btnGrp-image"],
          ["foreColor", "backColor"]
        ],
        btnsDef: {
          "btnGrp-image": {
            dropdown: ["insertImage", "upload"],
            ico: "insertImage"
          },
          format: {
            dropdown: ["p", "blockquote", "h1", "h2", "h3", "h4", "h5", "h6"],
            ico: "p"
          }
        },
        plugins: {
          upload: {
            serverPath:
              `${process.env.VUE_APP_API_URL}` +
              (this.strategy === "cover" ? "files/upload" : "uploads"),
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            },
            fileFieldName: "image",
            urlPropertyName: "url"
          }
        }
      },
      uploadSection: "",
      // Get more form https://chmln.github.io/flatpickr/options/
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: "M j, Y h:i K",
        altInput: true,
        dateFormat: "Y-m-d H:i:s",
        enableTime: true
      },
      post: {
        page_image: "",
        lang: 1
      },
      postDescription: "",
      categories: [],
      langs: [
        { name: "sr", fullName: "Serbian", id: 1 },
        { name: "en", fullName: "English", id: 2 }
        // { name: "de", fullName: "German", id: 3 }
      ],
      imageAltTags: [],
      tags: [],
      selectedTags: [],
      filteredImages: [],
      sortedImages: [],
      startTime: new Date(),
      timeout: false,
      errors: new Errors()
    };
  },
  mounted() {
    this.getCategories();
    this.getTags();
    if (this.duplicatedPost) {
      this.post.author_slug = this.duplicatedPost.author_slug;
      this.post.title = this.duplicatedPost.title;
      this.post.category_id = this.duplicatedPost.category_id;
      this.post.content = this.duplicatedPost.content;
      this.post.content_html = this.duplicatedPost.content_html;
      this.post.excerpt = this.duplicatedPost.excerpt;
      this.post.meta_description = this.duplicatedPost.meta_description;
      this.post.meta_title = this.duplicatedPost.meta_title;
      this.post.page_image = this.duplicatedPost.page_image;
      this.post.page_image_alt_text = this.duplicatedPost.page_image_alt_text;
      this.post.page_image_thumbnail = this.duplicatedPost.page_image_thumbnail;
    }
  },
  watch: {
    post() {
      this.startTime = this.post.published_time;
    },
    filteredImages() {
      this.sortedImages = [...this.filteredImages];
      this.sortedImages.sort((a, b) => (a.order > b.order ? 1 : -1));
    }
  },
  methods: {
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    loadImage(response) {
      this.post.page_image = response.url;
    },
    loadImageGallery(response) {
      this.filteredImages.push(response);
      this.imageAltTags[response.image_id] = "";
      this.post.video_url = null;
      this.post.video_alt_tag = null;
    },
    moveImageLeft(order) {
      this.filteredImages = this.sortedImages.map(image => {
        if (order === image.order) {
          image.order -= 1;
          return image;
        }
        if (order - 1 === image.order) {
          image.order += 1;
          return image;
        }
        return image;
      });
    },
    moveImageRight(order) {
      this.filteredImages = this.sortedImages.map(image => {
        if (order === image.order) {
          image.order += 1;
          return image;
        }
        if (order + 1 === image.order) {
          image.order -= 1;
          return image;
        }
        return image;
      });
    },
    deleteImage(imageForDeletion) {
      axios
        .delete(`uploads`, {
          data: {
            path: imageForDeletion
          }
        })
        .then(res => {
          if (res.data.data === true) {
            if (typeof imageForDeletion === "string") {
              this.post.page_image = "";
            } else {
              this.filteredImages = this.filteredImages.filter(image => {
                return image.image_id !== imageForDeletion.image_id;
              });
            }
          }
        });
    },
    save() {
      if (this.post.lang === 1) {
        this.post.lang = "sr";
      } else if (this.post.lang === 2) {
        this.post.lang = "en";
      } else {
        this.post.lang = "de";
      }
      let tagIDs = [];

      for (var i = 0; i < this.selectedTags.length; i++) {
        tagIDs[i] = this.selectedTags[i].id;
      }

      if (this.filteredImages.length) {
        let imageIDs = [];

        for (var j = 0; j < this.filteredImages.length; j++) {
          imageIDs[j] = this.filteredImages[j].image_id;
        }

        this.post.image_ids = JSON.stringify(imageIDs);
      }

      this.post.published_at = this.startTime;
      this.post.tags = JSON.stringify(tagIDs);
      this.post.image_alt_tags = JSON.stringify(this.imageAltTags);

      axios
        .post(`posts`, { ...this.post })
        .then(res => {
          this.$router.push(`/posts/${res.data.data.id}`);
        })
        .catch(err => this.errors.record(err.response.data.errors));
    },
    getCategories() {
      axios
        .get("categories/list")
        .then(resp => {
          this.categories = resp.data.data;
        })
        .catch(err => this.errors.record(err.response.data.errors));
    },
    getTags() {
      axios
        .get("tags/list")
        .then(resp => {
          this.tags = resp.data.data;
        })
        .catch(err => this.errors.record(err.response.data.errors));
    }
  }
};
</script>
<style scoped>
.mr-12 {
  padding-right: 12px;
}

.img-alt-tag {
  width: 251px;
}

.texteditor {
  padding: 0;
}

.texteditor label {
  padding: 10px 16px !important;
}

.selectionCard {
  background: #ffffff;
  border: 1px solid #e0e5ea;
  border-radius: 3px;
  padding: 15px;
  cursor: pointer;
  height: 160px;
  width: 160px;
  display: flex;
  margin-right: 12px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.selectionCard:hover {
  background-color: #f6f6f6;
  border-color: #006266;
  transition-timing-function: ease-in;
}

.sc-title {
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.4px;
  margin-bottom: 12px;
  color: #006266;
}

.sc-text {
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #979797;
}

.linkColor {
  color: #006266;
  text-decoration: underline;
  cursor: pointer;
}

.linkColor:hover {
  color: #2152d6;
}

.sc-title-wrapper {
  max-width: 90%;
  margin-right: 40px;
}

.embed-textarea {
  font-size: 18px;
  color: #616161;
  resize: none;
  cursor: pointer;
  padding: 12px;
}

.embed-textarea-wrapper {
  padding: 30px;
}

.embed-textarea-wrapper ::-webkit-input-placeholder {
  /* WebKit browsers */

  font-size: 12px;
  text-align: center;
  line-height: 200px;
  text-decoration: underline;
}

.embed-textarea-wrapper :-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  text-align: center;
  line-height: 200px;
  font-size: 12px;
  text-decoration: underline;
}

.embed-textarea-wrapper ::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  text-align: center;
  font-size: 12px;
  line-height: 200px;
  text-decoration: underline;
}

.embed-textarea-wrapper :-ms-input-placeholder {
  /* Internet Explorer 10+ */
  text-align: center;
  font-size: 12px;
  line-height: 200px;
  text-decoration: underline;
}

.square-upload {
  width: 180px;
  height: 170px;
}

.square-upload:first-child {
  border: none;
  margin: 0 auto;
  outline: 1px dashed lightgrey;
}

.gallery-div {
  position: relative;
  height: 100%;
  width: 100%;
}

.gallery-img-overlay:hover {
  opacity: 1;
  background: rgba(144, 144, 144, 0.3);
}

.gallery-img-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  transition: 0.3s ease;
  max-width: 200px;
  max-height: 200px;
}

.gallery-tag {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 58px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  color: black;
  padding-left: 5px;
  background-color: rgba(255, 255, 255, 0.8) !important;
  outline: none;
}

.img-delete {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.image-position-change {
  position: absolute;
  bottom: 8px;
  right: 8px;
  text-align: center;
  width: 64px;
  height: 32px;
  object-fit: contain;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.img-delete:hover,
.image-position-change:hover {
  background-color: #fff;
}
.gallery-right {
  transform: rotate(180deg);
}

.button-line {
  height: 100%;
  opacity: 0.1;
  border: solid 1px #212529;
}

.select-wrap {
  border-radius: 3px;
  border: solid 1px #e0e5ea;
  background-color: rgba(243, 244, 245, 0.2);
  height: 50px;
}
</style>
